import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IUser } from './IUser';
import { Observable, forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { Utils } from './Utils';

@Injectable({
    providedIn: 'root'
})
export class UserService {

  private addListPerm = 2;
  private manageListPerm = 2048;

  private _user: string;
  get user(): string {
      return this._user;
  }

  private _email: string;
  get email(): string {
      return this._email;
  }

  private _login: string;
  get login(): string {
      return this._login;
  }

  private _isAdmin: boolean;
  get isAdmin(): boolean {
      return this._isAdmin;
  }

  constructor(private http: HttpClient) {

  }

  public Init(configUrl: string) {
    return new Observable((observer) => {
        this.getCurrentUser(configUrl)
        .subscribe(user => {
            this._user = user.name;
            this._email = user.email;
            this._login = user.login;
            this.canUserChangeSettings(configUrl, user.login)
            .subscribe(val => {
              this._isAdmin = val;
              observer.next();
              observer.complete();
            }, err => {
              this.getCurrentUserPermission(configUrl)
              .subscribe(val => {
                this._isAdmin = val;
                observer.next();
                observer.complete();
              }, err2 => {
                console.log(err2);
              });
            });
        }, err => {
          this._isAdmin = false;
          observer.next();
          observer.complete();
        });
    });
  }

  public getCurrentUserPermission(configUrl: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
        const headers = new HttpHeaders().
        set('Accept', 'application/json;odata=verbose');

        const options = { headers: headers };
        this.http.get(Utils.removeSlash(configUrl) + `/_api/web/doesuserhavepermissions(@v)?@v={'High':'2048','Low':'2048'}`, options)
        .subscribe((res) => {
            try {
                if (res) {
                  const val = (<any>res).d.DoesUserHavePermissions;
                  observer.next(val);
                } else {
                  observer.error('Empty User');
                }
            } catch (error) {
                observer.error(error);
            } finally {
              observer.complete();
            }
        }, err => {
          observer.error(err);
          observer.complete();
        });
    });
  }

  public canUserChangeSettings(configUrl: string, login: string): Observable<boolean> {

    return new Observable<boolean>((observer) => {
      const headers = new HttpHeaders().set('Accept', 'application/json;odata=verbose');

      const options = { headers: headers };
      // tslint:disable-next-line: max-line-length
      this.http.get(`${Utils.removeSlash(configUrl)}/_api/web/getUserEffectivePermissions(@v)?@v='${encodeURIComponent(login)}'`, options)
      .subscribe((res) => {
          try {
              if (res) {
                const high = (<any>res).d.GetUserEffectivePermissions.High;
                const low = (<any>res).d.GetUserEffectivePermissions.Low;
                if (low) {
                  // tslint:disable-next-line: no-bitwise
                  const val = low & this.manageListPerm;
                  observer.next(val > 0);
                } else {
                  observer.error('Invalid LOW Permission');
                }
              } else {
                observer.error('Permissions failed');
              }
          } catch (error) {
              observer.error(error);
          } finally {
            observer.complete();
          }
      }, err => {
        observer.error(err);
        observer.complete();
      });
    });
  }

  public getCurrentUser(configUrl: string): Observable<IUser> {
    return new Observable<IUser>((observer) => {
        const headers = new HttpHeaders().
        set('Accept', 'application/json;odata=verbose');

        const options = { headers: headers };
        this.http.get(Utils.removeSlash(configUrl) + '/_api/web/CurrentUser', options)
        .subscribe((user) => {
            try {
                if (user) {
                  const u = <IUser> {name: (<any>user).d.Title,
                                email: (<any>user).d.Email,
                                login: (<any>user).d.LoginName};
                  observer.next(u);
                } else {
                  observer.error('Empty User');
                }
            } catch (error) {
                observer.error(error);
            } finally {
              observer.complete();
            }
        }, err => {
          observer.error(err);
          observer.complete();
        });
    });
  }
}
